import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkPlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBookmarkPlus"><Path d="M19.5 21V2.5H4.5V21L12 17L19.5 21Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 6.5V13.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M15.5 10L8.5 10" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBookmarkPlus;
